import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {OnboardingModal} from 'shells/onboarding-modal/onboarding-modal';

import {BodyLeads, GraphicLeads} from './slide-leads';
import {BodyPeopleCompanies, GraphicPeopleCompanies} from './slide-people-companies';
import {BodyPipeline, GraphicPipeline} from './slide-pipeline';
import {BodyTeam, GraphicTeam} from './slide-team';

const pages = [
    {
        body: <BodyPeopleCompanies />,
        // @ts-expect-error
        art: {background: colors.yellow, image: (props) => <GraphicPeopleCompanies {...props} />},
    },
    {
        body: <BodyLeads />,
        // @ts-expect-error
        art: {background: colors.yellow, image: (props) => <GraphicLeads {...props} />},
    },
    {
        body: <BodyPipeline />,
        // @ts-expect-error
        art: {background: colors.yellow, image: (props) => <GraphicPipeline {...props} />},
    },
    {
        body: <BodyTeam />,
        art: {image: () => <GraphicTeam />},
    },
];

type Props = {
    onClose: () => void;
};

export class CurtainModal extends React.PureComponent<Props> {
    componentDidMount() {
        const sidebar = document.getElementById('sidebar');
        if (sidebar) {
            sidebar.style.zIndex = '10001';
            sidebar.style.pointerEvents = 'none';
            sidebar.style.borderRight = '0';
        }
    }

    componentWillUnmount() {
        const sidebar = document.getElementById('sidebar');
        if (sidebar) {
            sidebar.removeAttribute('style');
        }
    }

    render() {
        return (
            <OnboardingModal
                // @ts-expect-error
                pages={pages}
                onClose={this.props.onClose}
                onFinish={this.handleFinish}
                canClickOutsideToClose={false}
            />
        );
    }

    handleFinish = () => {
        this.props.onClose();
    };
}
